(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-award-badge"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var GOLD = '#c9a84c';
  var TEAL = '#2d5a56';
  var DARK = '#1a1a1a';
  var ns   = 'http://www.w3.org/2000/svg';
  var CX   = 175, CY = 175;

  /* ── Helpers ── */
  function rad(deg) { return deg * Math.PI / 180; }

  /* angle: 0° = 12-o'clock, clockwise */
  function pt(angleDeg, r) {
    var a = rad(angleDeg - 90);
    return [CX + r * Math.cos(a), CY + r * Math.sin(a)];
  }

  /* Scale: 800 at 135° → 1 at 405°(=45°), 270° arc */
  function valToAngle(v) {
    return 135 + (800 - v) / 799 * 270;
  }

  function svgEl(tag, attr, parent) {
    var e = document.createElementNS(ns, tag);
    Object.keys(attr).forEach(function (k) { e.setAttribute(k, attr[k]); });
    if (parent) parent.appendChild(e);
    return e;
  }

  function drawTick(svg, angleDeg, rOuter, rInner, stroke, sw) {
    var p1 = pt(angleDeg, rOuter), p2 = pt(angleDeg, rInner);
    svgEl('line', {
      x1: p1[0].toFixed(2), y1: p1[1].toFixed(2),
      x2: p2[0].toFixed(2), y2: p2[1].toFixed(2),
      stroke: stroke, 'stroke-width': sw, 'stroke-linecap': 'round'
    }, svg);
  }

  function drawLabel(svg, content, angleDeg, r, size, fill, weight) {
    var p = pt(angleDeg, r);
    var t = document.createElementNS(ns, 'text');
    t.textContent = content;
    t.setAttribute('x', p[0].toFixed(2));
    t.setAttribute('y', p[1].toFixed(2));
    t.setAttribute('text-anchor', 'middle');
    t.setAttribute('dominant-baseline', 'middle');
    t.setAttribute('fill', fill || GOLD);
    t.setAttribute('font-size', size || '7.5');
    t.setAttribute('font-family', 'var(--font-body-family, system-ui, sans-serif)');
    t.setAttribute('letter-spacing', '0.03em');
    if (weight) t.setAttribute('font-weight', weight);
    svg.appendChild(t);
    return t;
  }

  /* Smooth easing: approx cubic-bezier(0.4, 0, 0.15, 1) */
  function easeInOut(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animateHand(handEl, fromAngle, toAngle, duration, delay) {
    setTimeout(function () {
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var elapsed  = ts - start;
        var progress = Math.min(elapsed / duration, 1);
        var angle    = fromAngle + (toAngle - fromAngle) * easeInOut(progress);
        handEl.setAttribute('transform',
          'translate(' + CX + ',' + CY + ') rotate(' + angle.toFixed(3) + ')');
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, delay);
  }

  function buildDial(svg) {
    /* Clear fallback circles */
    while (svg.firstChild) svg.removeChild(svg.firstChild);

    /* ── Outer bezel rings ── */
    svgEl('circle', { cx: CX, cy: CY, r: 165, fill: '#f8f7f5', stroke: '#e0dcd6', 'stroke-width': 1 }, svg);
    svgEl('circle', { cx: CX, cy: CY, r: 153, fill: 'white',   stroke: '#d9d5cf', 'stroke-width': 0.5 }, svg);
    svgEl('circle', { cx: CX, cy: CY, r: 150, fill: 'none',    stroke: '#f0ede8', 'stroke-width': 2 }, svg);

    /* ── Scale track arc (135° → 45°, 270°) ── */
    var ARC_R = 137;
    var sArc = pt(135, ARC_R), eArc = pt(45, ARC_R);
    svgEl('path', {
      d: ['M', sArc[0].toFixed(2), sArc[1].toFixed(2),
          'A', ARC_R, ARC_R, '0 1 1', eArc[0].toFixed(2), eArc[1].toFixed(2)].join(' '),
      fill: 'none', stroke: '#eeebe5', 'stroke-width': 22, 'stroke-linecap': 'round'
    }, svg);

    /* Thin gold outer arc border */
    var BORDER_R = 148;
    var sBo = pt(135, BORDER_R), eBo = pt(45, BORDER_R);
    svgEl('path', {
      d: ['M', sBo[0].toFixed(2), sBo[1].toFixed(2),
          'A', BORDER_R, BORDER_R, '0 1 1', eBo[0].toFixed(2), eBo[1].toFixed(2)].join(' '),
      fill: 'none', stroke: GOLD, 'stroke-width': 0.6, 'stroke-linecap': 'round', opacity: 0.35
    }, svg);

    /* ── Micro ticks every 10 units ── */
    for (var mv = 10; mv <= 800; mv += 10) {
      if (mv % 50 === 0) continue;
      drawTick(svg, valToAngle(mv), 146, 141, '#ccc', 0.4);
    }

    /* ── Minor ticks at 50-unit intervals ── */
    [50, 150, 250, 350, 450, 550, 650, 750].forEach(function (v) {
      drawTick(svg, valToAngle(v), 147, 134, '#bbb', 0.85);
    });

    /* ── Major ticks + labels at each 100 ── */
    [100, 200, 300, 400, 500, 600, 700, 800].forEach(function (v) {
      var a = valToAngle(v);
      drawTick(svg, a, 148, 126, GOLD, 1.5);
      drawLabel(svg, String(v), a, 112, '7', GOLD);
    });

    /* "1" marker at end of scale */
    drawTick(svg, valToAngle(1), 148, 126, GOLD, 1.5);
    drawLabel(svg, '1', valToAngle(1), 112, '7', GOLD);

    /* ── Special position 13 marker ── */
    var a13 = valToAngle(13); /* ≈ 401.3° */
    drawTick(svg, a13, 152, 121, GOLD, 3);
    drawLabel(svg, '13', a13, 107, '10', GOLD, 'bold');

    /* ── Hand (lancetta blued-steel) ── */
    /* Drawn pointing straight UP in local coords (0,-y = 12-o'clock).
       SVG transform="translate(CX,CY) rotate(angle)" positions it. */
    var handG = document.createElementNS(ns, 'g');
    handG.id  = 'subdial-hand-' + svg.className.baseVal.replace(/\s/g, '');
    /* Start at scale position 800 (135°) */
    handG.setAttribute('transform', 'translate(' + CX + ',' + CY + ') rotate(135)');
    svg.appendChild(handG);

    /* Lance polygon: tip at (0,-108), shoulders at (±3,-18), tail at (0,22) */
    svgEl('polygon', {
      points: [
        '0,-109',
        '2.8,-20',
        '1.2,20',
        '0,23',
        '-1.2,20',
        '-2.8,-20'
      ].join(' '),
      fill: TEAL
    }, handG);

    /* ── Center hub ── */
    svgEl('circle', { cx: CX, cy: CY, r: 11, fill: DARK, stroke: GOLD, 'stroke-width': 1.5 }, svg);
    svgEl('circle', { cx: CX, cy: CY, r: 5,  fill: GOLD }, svg);
    svgEl('circle', { cx: CX, cy: CY, r: 2,  fill: DARK }, svg);

    /* ── Inner text ── */
    svgEl('line', {
      x1: CX - 50, y1: CY + 29, x2: CX + 50, y2: CY + 29,
      stroke: GOLD, 'stroke-width': 0.5, opacity: 0.38
    }, svg);

    [
      { t: 'LA REPUBBLICA',          y: CY + 38, size: '7.2', fill: TEAL, ls: '0.2em', w: null },
      { t: 'CAMPIONI DELLA CRESCITA', y: CY + 49, size: '5.8', fill: TEAL, ls: '0.1em', w: null },
      { t: '2024',                    y: CY + 61, size: '9',   fill: GOLD, ls: '0.25em', w: 'bold' }
    ].forEach(function (item) {
      var t = document.createElementNS(ns, 'text');
      t.textContent = item.t;
      t.setAttribute('x', CX);
      t.setAttribute('y', item.y);
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('dominant-baseline', 'middle');
      t.setAttribute('fill', item.fill);
      t.setAttribute('font-size', item.size);
      t.setAttribute('font-family', 'var(--font-body-family, system-ui, sans-serif)');
      t.setAttribute('letter-spacing', item.ls);
      if (item.w) t.setAttribute('font-weight', item.w);
      svg.appendChild(t);
    });

    /* ── Card reveal + hand animation ── */
    var card = svg.closest('.about-award__card');
    if (!card) return;

    var isDesignMode = window.Shopify && window.Shopify.designMode;
    var isReduced    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showImmediately() {
      /* Mostra subito senza animazione */
      card.classList.add('is-visible');
      handG.setAttribute('transform',
        'translate(' + CX + ',' + CY + ') rotate(' + a13.toFixed(2) + ')');
    }

    /* Nell'editor Shopify o senza IntersectionObserver → mostra subito */
    if (isDesignMode || isReduced || !('IntersectionObserver' in window)) {
      showImmediately();
      return;
    }

    /* Animazione al primo scroll */
    card.setAttribute('data-animate', '');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        card.classList.add('is-visible');
        animateHand(handG, 135, a13, 2600, 400);
        observer.unobserve(entry.target);
      });
    /* threshold 0 → si attiva appena un pixel è visibile */
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });

    observer.observe(card);
  }

  /* ── Init: esegue al caricamento della pagina ── */
  function initAll() {
    document.querySelectorAll('.about-award__svg').forEach(buildDial);
  }

  initAll();

  /* ── Shopify editor: ri-esegue quando la sezione viene
     aggiunta/ricaricata dinamicamente nel Customizer ── */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.about-award__svg').forEach(buildDial);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-split-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var values = document.querySelectorAll('.about-split__value');
  if (!values.length) return;

  /* Stato iniziale via JS: evita flash nell'editor Shopify */
  values.forEach(function (v) {
    v.setAttribute('data-animate', '');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var idx = Array.prototype.indexOf.call(values, el);
        /* Stagger 160ms per colonna — identico ad atelier-services */
        setTimeout(function () {
          el.classList.add('is-visible');
        }, idx * 160);
        observer.unobserve(el);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  values.forEach(function (v) {
    observer.observe(v);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us-template"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cards = document.querySelectorAll('.about-us__value-card');
  if (!cards.length) return;

  /* Stato iniziale via JS: evita flash nell'editor Shopify */
  cards.forEach(function (card) {
    card.setAttribute('data-animate', '');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var idx = Array.prototype.indexOf.call(cards, card);
        /* Stagger 160ms per colonna — identico ad atelier-services */
        setTimeout(function () {
          card.classList.add('is-visible');
        }, idx * 160);
        observer.unobserve(card);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  cards.forEach(function (card) {
    observer.observe(card);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-booking"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var header = document.querySelector('.atelier-booking__header');
  var formWrap = document.querySelector('.atelier-booking__form-wrap');
  var targets = [header, formWrap].filter(Boolean);
  if (!targets.length) return;

  /* Imposta stato iniziale via JS */
  targets.forEach(function (el) {
    el.setAttribute('data-animate', '');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-services"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── 1. Scroll-reveal staggered per le card ── */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var cards = document.querySelectorAll('.atelier-services__card');
    if (cards.length) {
      cards.forEach(function (card) {
        card.setAttribute('data-animate', '');
      });

      var cardObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var card = entry.target;
            var idx = Array.prototype.indexOf.call(cards, card);
            setTimeout(function () {
              card.classList.add('is-visible');
            }, idx * 160);
            cardObserver.unobserve(card);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      cards.forEach(function (card) {
        cardObserver.observe(card);
      });
    }
  }

  /* ── 2. Smart Service Selection ──
     Intercetta i bottoni con data-service, esegue smooth scroll
     verso il form e pre-seleziona l'opzione corrispondente.      */
  var SERVICE_VALUES = {
    'visione-boutique':   'Visione in Boutique',
    'revisione-meccanica': 'Revisione Meccanica'
  };

  var HEADER_OFFSET = 90; /* px — altezza header sticky */

  var serviceBtns = document.querySelectorAll('[data-service]');
  serviceBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key       = btn.getAttribute('data-service');
      var formWrap  = document.getElementById('atelier-contact-form');
      var select    = document.getElementById('AtelierServiceSelect');

      if (!formWrap) return;

      /* Imposta il valore della select */
      if (select && SERVICE_VALUES[key]) {
        select.value = SERVICE_VALUES[key];

        /* Flash visivo: rimuovi → reflow → aggiungi classe */
        select.classList.remove('atelier-services__form-select--flash');
        void select.offsetWidth; /* forza reflow per riavviare l'animazione */
        select.classList.add('atelier-services__form-select--flash');
        setTimeout(function () {
          select.classList.remove('atelier-services__form-select--flash');
        }, 1100);
      }

      /* Smooth scroll verso il form */
      var top = formWrap.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chi-siamo-dicono"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var isReduced    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesignMode = window.Shopify && window.Shopify.designMode;
  var hasIO        = 'IntersectionObserver' in window;

  /* In the editor show everything immediately */
  if (isReduced || isDesignMode || !hasIO) return;

  function observeEl(el, delay) {
    el.setAttribute('data-animate', '');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (delay) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
          } else {
            entry.target.classList.add('is-visible');
          }
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    io.observe(el);
  }

  function init() {
    var pressInner = document.querySelector('.chi-siamo-dicono__press-inner');
    if (pressInner) observeEl(pressInner, 0);

    document.querySelectorAll('.chi-siamo-dicono__award-tile').forEach(function (tile) {
      var delay = tile.classList.contains('chi-siamo-dicono__award-tile--2025') ? 140 : 0;
      observeEl(tile, delay);
    });
  }

  init();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.chi-siamo-dicono')) init();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chi-siamo-manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var el = document.querySelector('.chi-siamo-manifesto__inner');
  if (!el) return;

  el.setAttribute('data-animate', '');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  observer.observe(el);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chi-siamo-valori"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = document.querySelectorAll('.chi-siamo-valori__item');
  if (!items.length) return;

  /* Stato iniziale via JS: evita flash nell'editor Shopify */
  items.forEach(function (item) {
    item.setAttribute('data-animate', '');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var item = entry.target;
        var idx = Array.prototype.indexOf.call(items, item);
        /* Stagger 160ms per colonna */
        setTimeout(function () {
          item.classList.add('is-visible');
        }, idx * 160);
        observer.unobserve(item);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = [
    document.querySelector('.lux-contact__page-header'),
    document.querySelector('.lux-contact__card'),
    document.querySelector('.lux-contact__form-section'),
  ].filter(Boolean);

  targets.forEach(function (el) {
    el.setAttribute('data-animate', '');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuation-service"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Scroll-reveal: fade-in-up — ordine header → how → card ── */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var animTargets = [
      document.querySelector('.valuation__header'),
      document.querySelector('.valuation__how'),
      document.querySelector('.valuation__card'),
    ].filter(Boolean);

    animTargets.forEach(function (el) {
      el.setAttribute('data-animate', '');
    });

    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.07, rootMargin: '0px 0px -30px 0px' }
    );

    animTargets.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ── Cloudinary upload ──
     Le foto vengono caricate su Cloudinary appena selezionate.
     Gli URL risultanti vengono inseriti come input nascosti nel form,
     così Shopify li riceve come normali campi testo nell'email.
     Cloud: dv4cghhr8 · Preset: valuation-watches (unsigned)
  ── */
  var uploadArea = document.getElementById('ValUploadArea');
  var fileInput  = document.getElementById('ValSvc-photos');
  var filesList  = document.getElementById('ValUploadFiles');
  var formEl     = document.getElementById('ValuationServiceForm');
  var submitBtn  = formEl ? formEl.querySelector('.valuation__submit') : null;

  if (!uploadArea || !fileInput || !filesList) return;

  var UPLOAD_URL    = 'https://api.cloudinary.com/v1_1/dv4cghhr8/image/upload';
  var UPLOAD_PRESET = 'valuation-watches';
  var MAX_FILES     = 6;
  var MAX_MB        = 10;
  var ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

  function clearPhotoInputs() {
    if (!formEl) return;
    formEl.querySelectorAll('input[data-photo-url]').forEach(function (el) { el.remove(); });
  }

  function setStatus(msg, isError) {
    filesList.textContent = msg;
    filesList.hidden = false;
    filesList.style.color = isError ? '#c0392b' : '';
  }

  /* Valida i file prima di procedere, restituisce il primo errore trovato */
  function validate(arr) {
    if (arr.length > MAX_FILES) {
      return 'Puoi allegare al massimo ' + MAX_FILES + ' foto per richiesta.';
    }
    for (var i = 0; i < arr.length; i++) {
      var f = arr[i];
      if (ALLOWED_TYPES.indexOf(f.type) === -1) {
        return '"' + f.name + '" non supportato — usa JPG, PNG o WEBP.';
      }
      if (f.size > MAX_MB * 1024 * 1024) {
        return '"' + f.name + '" supera i ' + MAX_MB + ' MB consentiti.';
      }
    }
    return null;
  }

  function uploadFile(file) {
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', UPLOAD_PRESET);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', UPLOAD_URL, true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          try { resolve(JSON.parse(xhr.responseText).secure_url); }
          catch (e) { reject(e); }
        } else {
          reject(new Error('HTTP ' + xhr.status));
        }
      };
      xhr.onerror = function () { reject(new Error('network')); };
      xhr.send(fd);
    });
  }

  function handleFiles(files) {
    if (!files || files.length === 0) {
      filesList.hidden = true;
      clearPhotoInputs();
      return;
    }

    var arr = Array.from(files);
    clearPhotoInputs();

    var err = validate(arr);
    if (err) {
      setStatus(err, true);
      return;
    }

    setStatus((arr.length === 1 ? '1 foto' : arr.length + ' foto') + ' — caricamento in corso...', false);
    if (submitBtn) submitBtn.disabled = true;

    var done = 0;

    Promise.all(
      arr.map(function (file, i) {
        return uploadFile(file).then(function (url) {
          done++;
          setStatus('Caricamento: ' + done + ' / ' + arr.length + '...', false);
          return url;
        });
      })
    )
    .then(function (urls) {
      /* Append in ordine corretto solo dopo che tutti gli upload sono completati */
      urls.forEach(function (url, i) {
        var input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = 'contact[Foto ' + (i + 1) + ']';
        input.value = url;
        input.setAttribute('data-photo-url', '');
        formEl.appendChild(input);
      });
      var n = urls.length;
      setStatus('✓ ' + (n === 1 ? '1 foto caricata' : n + ' foto caricate') + ' — pronte per l\'invio', false);
      if (submitBtn) submitBtn.disabled = false;
    })
    .catch(function () {
      setStatus('Errore nel caricamento — verifica la connessione e riprova.', true);
      clearPhotoInputs();
      if (submitBtn) submitBtn.disabled = false;
    });
  }

  fileInput.addEventListener('change', function () {
    handleFiles(this.files);
  });

  uploadArea.addEventListener('dragover', function (e) {
    e.preventDefault();
    uploadArea.classList.add('is-dragover');
  });

  ['dragleave', 'dragend'].forEach(function (evt) {
    uploadArea.addEventListener(evt, function () {
      uploadArea.classList.remove('is-dragover');
    });
  });

  uploadArea.addEventListener('drop', function (e) {
    e.preventDefault();
    uploadArea.classList.remove('is-dragover');
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
      handleFiles(e.dataTransfer.files);
    }
  });

  uploadArea.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      fileInput.click();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
